import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import axios from "axios";
import {defaultVariabls} from "../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import {setStore} from "trim-redux";
import Grid from "@material-ui/core/Grid/Grid";
import {FieldSkeleton} from "../../components/Skeletons/FieldSkeleton";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import Skeleton from "@material-ui/lab/Skeleton/Skeleton";
import SubTitle from "../../components/elements/SubTitle";
import Button from "@material-ui/core/Button/Button";

class TagHolderPro extends React.Component {
    state = {
        tags: null,
        tagsDef: null,
        searchedTags: null,
        loading:true,
        output:[],
        input:[],
        defaults: [],
        search:"",
        show:false,
        language:this.props.language,
    };
    classes = this.props.classes;
    componentDidMount(){
        this.setState({
            input: this.props.inPut,
            language:this.props.language,

        })
        if(this.props.edit === undefined){
            this.handleShow();
        }
    }
    async componentDidUpdate(prevProps){
        if(this.state.language !== this.props.language){
            await this.setState({
                language:this.props.language,
            })
            await this.handleShow();
        }
    }
    async handleShow(){
        this.setState({
            show:true
        })
        await this.loadData();
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/tags/view/${this.state.language}`, config)
                .then(response => {
                    this.setState({
                        tags: response.data,
                    })
                })
                .catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
            await axios.get(`${defaultVariabls.url}/tags/view`, config)
                .then(response => {
                    this.setState({
                        tagsDef: response.data,
                    })
                    this.loadDefaults();
                })
                .catch(error => {
                    console.log(error)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }
    async loadDefaults(){
        let {tagsDef,input} = this.state;
        if(input !== undefined){
            let temp =[];
            if(!!tagsDef){
                await tagsDef.map((item,index) =>{
                    return this.state.input.indexOf(item.id) > -1 ? temp.push(index) : null
                })
            }
            let defaults = []
            await temp.map(row => {
                defaults.push(tagsDef[row].id)
            })
            await this.setState({
                defaults,
                output:defaults,
                loading:false
            })
        }else{
            await this.setState({
                defaults:[],
                loading:false,
            })
        }
    }
    async handChange(value){
        let output = [];
        await value.map(row => {
            output.push(row.id)
            return true
        })
        await this.setState({output})
        await this.props.outPut(output);
    }
    async handleChangeCheckbox(id){
        let {output} = this.state;
        let index = output.indexOf(id)
        if(index > -1){
            output.splice(index, 1);
        }else{
            output.push(id);
        }
        this.props.outPut(output);
        await this.setState({
            output
        })
    }
    handleChangeSearch(e){
        let {language} = this.state;
        let text = e.target.value;
        if(text === ""){
            this.setState({
                searchedTags:null
            })
        }else{
            let result = [];
            let tags = this.state.tags;
            tags.map((tag) => (
                // eslint-disable-next-line
                language === "en" ?
                tag.name.toLowerCase().search(text.toLowerCase()) !== -1 ? result.push(tag) : null
                    :
                    !!tag.translates &&
                    tag.translates[0].name.toLowerCase().search(text.toLowerCase()) !== -1 ? result.push(tag) : null

            ))
            this.setState({
                searchedTags:result
            })
        }

    }
    render(){
        let {tags,searchedTags,loading,output,show,language} = this.state;
        if(searchedTags !== null){
            tags = searchedTags
        }
        return (
            <React.Fragment>
                {
                    show ?
                        loading ?
                            <Grid container spacing={2} direction="row">
                                <Grid item xs={12}>
                                    <SubTitle style={{marginBottom:0}} align="left">{Translate.tags}</SubTitle>
                                    <FieldSkeleton/>
                                    <br/>
                                    <Skeleton  variant="rect" height={280} />
                                </Grid>
                            </Grid>
                            :
                            <Grid container spacing={2} direction="row">
                                <Grid item xs={12} style={{paddingBottom:0}}>
                                    <SubTitle style={{marginBottom:0}} align="left">{Translate.tags}</SubTitle>
                                </Grid>
                                <Grid item xs={12} style={{paddingTop:0}}>
                                    <TextField
                                        label= {Translate.search}
                                        fullWidth
                                        margin="normal"
                                        variant="outlined"
                                        size="small"
                                        name="search"
                                        InputProps={{
                                            startAdornment: <SearchRoundedIcon />
                                        }}
                                        onChange={this.handleChangeSearch.bind(this)}

                                    />
                                    {this.state.search}
                                    <List dense disablePadding className="categoryHolderPro">
                                        {
                                            tags.map((tag,index) => (
                                                <React.Fragment>
                                                    <ListItem key={index} dense button onClick={() => this.handleChangeCheckbox(tag.id)}>
                                                        <ListItemIcon>
                                                            <Checkbox
                                                                edge="start"
                                                                checked={output.indexOf(tag.id) !== -1}
                                                                name={tag.name}
                                                                disableRipple
                                                            />
                                                        </ListItemIcon>
                                                        <ListItemText  className="tagParent"  primary={language === "en" ? tag.name : !!tag.translates && tag.translates[0].name} />
                                                    </ListItem>
                                                </React.Fragment>


                                            ))
                                        }
                                    </List>

                                </Grid>
                            </Grid> :
                        <Grid container spacing={2} direction="row" className={this.classes.GridAsaPaper} style={{marginTop:40,paddingBottom:20}}>
                            <Grid item xs={12}>
                                <SubTitle style={{marginBottom:0}} align="left">{Translate.tags}</SubTitle>
                                <br/>
                                <Button color="primary" variant="outlined" onClick={this.handleShow.bind(this)}>{Translate.edit}</Button>
                            </Grid>
                        </Grid>

                }
            </React.Fragment>

        );
    }
}

export default withSnackbar(withRouter(withStyles(Styles)(TagHolderPro)));